<template>
  <div class="bottomMenu">
    <mt-tabbar v-model="selected" fixed>
		  <mt-tab-item id="首页">
		    <img slot="icon" :src="icon1">
		             首页
		  </mt-tab-item>
		  <mt-tab-item id="分类">
		    <img slot="icon" :src="icon2">
		            分类
		  </mt-tab-item>
		  <mt-tab-item id="我的">
		    <img slot="icon" :src="icon3">
		           我的
		  </mt-tab-item>
    </mt-tabbar>
  </div>
</template>

<script>
export default {
  data () {
    return { 
    	 selected: '首页',
    	 icon1:"../../static/images/home_ico.png",
    	 icon2:"../../static/images/cate_ico.png",
    	 icon3:"../../static/images/my_ico.png"
    }
  },
  watch: {
    selected: function (val) {
      if(val=="首页"){
      	this.$router.push({path: '/'});
      }else if(val=="分类"){
      	this.$router.push({path: '/Category'});
      	localStorage.setItem("tid","-1");
      }else{
      	this.$router.push({path: '/UserCenter'});
      }
    }
  },
   created:function(){
     var path=this.$route.path;
     if(path=="/"){
       	this.icon1="../../static/images/home_ico_active.png"
     	  this.selected="首页"
     }if(path=="/Category"){
     	  this.icon2="../../static/images/cate_ico_active.png"
     	  this.selected="分类"
     }if(path=="/UserCenter"){
     	  this.icon3="../../static/images/my_ico_active.png"
     	  this.selected="我的"
     }
	},
 }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/BottomMenu.vue